<template>
    <div class="payment-method d-flex flex-column align-items-center">
        <div class="d-flex flex-column align-items-center">
            <h1>Your stage is Set!</h1>
            <p class="payment-discription">
                Now lets add payment details to share your events with the Talent Pool
            </p>
            <p class="payment-experience">
                Experience Hedlyner risk-free with our one-month free trial! Unlock premium
                features, explore a diverse range of talented artists or invite your favorites.
                Start transforming your live music bookings today!
            </p>
        </div>
        <div class="payment-form d-flex flex-column">
            <p class="payment-title">Payment Preferences</p>
            <input
                type="text"
                v-model="cardHolder"
                placeholder="Card holder *"
                :class="{
                    'error-field': errorCardHolder,
                    'input-border': !errorCardHolder
                }"
                required
            />
            <input
                ref="cardNumber"
                @input="getCartNumber"
                type="number"
                v-model="cardNumber"
                placeholder="Card number *"
                :class="{
                    'error-field': errorCardNumer,
                    'input-border': !errorCardNumer
                }"
                required
                data-testid="cardNumber-input"
            />
            <div class="d-flex">
                <input
                    ref="cardExpDate"
                    type="text"
                    class="me-3"
                    @input="getCardExpDate"
                    v-model="cardExpDate"
                    placeholder="Exp Date *"
                    :class="{
                        'error-field': errorCardExpDate,
                        'input-border': !errorCardExpDate
                    }"
                    required
                />
                <input
                    ref="cvc"
                    @input="getCVC"
                    v-model="cvc"
                    type="text"
                    placeholder="CVC *"
                    :class="{
                        'error-field': errorCVC,
                        'input-border': !errorCVC
                    }"
                    required
                    data-testid="cvc-input"
                />
            </div>
        </div>
        <div class="d-flex flex-column">
            <p class="plans">Subscription Plans</p>
            <button class="subscribe-btn" @click="subscribe">SUBSCRIBE</button>
            <p @click="skipPaymant" class="skip-btn">Skip</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PaymentModalContent',
        props: {
            mode: {
                type: String
            }
        },
        data: () => ({
            cardHolder: '',
            cardNumber: '',
            cardExpDate: '',
            cvc: '',
            errorCardNumer: false,
            errorCardHolder: false,
            errorCardExpDate: false,
            errorCVC: false,
            modalMode: ''
        }),
        methods: {
            getCartNumber() {
                if (this.$refs.cardNumber.value > 16) {
                    this.$refs.cardNumber.value = this.$refs.cardNumber.value.substr(0, 16)
                    this.cardNumber = this.$refs.cardNumber.value.substr(0, 16)
                }
            },
            getCVC() {
                if (this.$refs.cvc.value > 3) {
                    this.$refs.cvc.value = this.$refs.cvc.value.substr(0, 3)
                    this.cvc = this.$refs.cvc.value.substr(0, 3)
                }
            },
            getCardExpDate() {
                const value = this.$refs.cardExpDate.value
                let formattedValue = value.replace(/\D/g, '').slice(0, 4)
                if (formattedValue.length > 2) {
                    formattedValue = formattedValue.slice(0, 2) + '/' + formattedValue.slice(2)
                }
                this.$refs.cardExpDate.value = formattedValue
                this.cardExpDate = formattedValue
            },
            skipPaymant() {
                this.$emit('update:mode', 'skipPaymentInfo')
            },
            subscribe() {
                this.cardHolder
                    ? (this.errorCardHolder = false)
                    : (this.errorCardHolder = true)
                this.cardNumber ? (this.errorCardNumer = false) : (this.errorCardNumer = true)
                this.cardExpDate
                    ? (this.errorCardExpDate = false)
                    : (this.errorCardExpDate = true)
                this.cvc ? (this.errorCVC = false) : (this.errorCVC = true)
                if (this.cardHolder && this.cardNumber && this.cardExpDate && this.cvc) {
                    this.$emit('update:mode', 'confirm')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .payment-method {
        padding: 80px 140px 60px 140px;
    }
    .payment-title {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #ffffff;
        text-align: center;
    }
    .payment-form {
        margin-top: 60px;
        margin-bottom: 70px;
    }
    .payment-form input {
        border-radius: 100px;
        padding: 17px 30px;
        background-color: #ffffff00;
        margin-bottom: 15px;
        color: #ffffff;
    }

    input::placeholder {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 150%;
    }
    h1 {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 800;
        font-size: 30px;
        line-height: 37px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #ffffff;
        margin-bottom: 30px;
    }
    .payment-discription {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #ffffff;
        max-width: 540px;
    }
    .payment-experience {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 34px;
        text-align: center;
        color: #ffffff;
        max-width: 670px;
    }
    .plans {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.1em;
        color: #ffffff;
        text-align: center;
    }
    .subscribe-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 20px;
        gap: 10px;
        min-width: 460px;
        background: #d7eb5a;
        border-radius: 100px;
        border: 0px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #1b0d29;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .error-field {
        border: 1px solid #ca2121;
    }
    .input-border {
        border: 1px solid #ffffff63;
    }
    .skip-btn {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        letter-spacing: 1.25px;
        text-transform: uppercase;
        color: #ffffff;
        cursor: pointer;
        margin-top: 20px;
    }
</style>
